import App from "./App";
import { createRoot } from "react-dom/client";
import { StrictMode } from "react";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import { registerServiceWorker } from "./serviceWorkerRegistration";
import { initPwaInstallPrompt } from "./utils/pwaInstallPrompt";

document.addEventListener("DOMContentLoaded", () => {
  registerServiceWorker();
  initPwaInstallPrompt();
});
const domNode = document.getElementById("root") as HTMLDivElement;
const root = createRoot(domNode);
root.render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
